module.exports = {"language":"es-ES","mapOptions":{"minZoom":2,"maxZoom":22,"mapTypeControl":false,"fullscreenControl":false,"streetViewControl":false},"defaultBounds":{"southWest":{"lat":36.3267,"lng":-10.848696},"northEast":{"lat":43.711913,"lng":4.42518}}}


//////////////////
// WEBPACK FOOTER
// ./demo/components/map-component/src/defaultMapConfig/mapConfig.json
// module id = eh77
// module chunks = 1